import type { CSSProperties } from 'react';

import { sendErrorEvent } from '@trello/error-reporting';
import { smallestPreviewBiggerThan } from '@trello/image-previews';
import { token } from '@trello/theme';

import { useTemplateBackgroundImageScaleQuery } from './TemplateBackgroundImageScaleQuery.generated';

export const useTemplateBackgroundStyle = (
  boardId: string,
  backgroundColor?: string,
  backgroundUrl?: string,
) => {
  const css: CSSProperties = {};
  const { data, error, loading } = useTemplateBackgroundImageScaleQuery({
    variables: {
      idBoard: boardId,
    },
    waitOn: ['None'],
  });

  if (backgroundUrl) {
    let scaledBackgroundUrl = backgroundUrl;

    if (loading) {
      return {
        loading,
        templateBackgroundStyle: css,
      };
    }

    if (error) {
      sendErrorEvent(new Error(error.message), {
        tags: {
          ownershipArea: 'trello-web-eng',
        },
        extraData: {
          networkError: error.networkError ? error.networkError.message : false,
          extraInfo: error.extraInfo,
          graphQLErrors: error.graphQLErrors.toString(),
          stack: error.stack ? error.stack : false,
          name: error.name,
        },
      });
    } else {
      const backgroundImageScaled =
        (!!data &&
          !!data.board &&
          !!data.board.prefs &&
          !!data.board.prefs.backgroundImageScaled &&
          data.board.prefs.backgroundImageScaled) ||
        undefined;

      const preview =
        !!data && smallestPreviewBiggerThan(backgroundImageScaled, 300, 150);
      scaledBackgroundUrl = (!!preview && preview.url) || backgroundUrl;
    }

    css.backgroundImage = `url('${scaledBackgroundUrl}')`;
    css.backgroundSize = 'cover';
    css.backgroundPosition = 'center';
  } else {
    css.backgroundColor =
      backgroundColor || token('color.background.brand.bold', '#0C66E4');
  }

  return {
    loading: false,
    templateBackgroundStyle: css,
  };
};
